export const ReferralProgramHistoryStatus = {
  None: 0,
  Pending: 1,
  Sent: 2,
  Purchased: 3
}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/referral.enum.js